import { render, staticRenderFns } from "./WebPaymentQueueWidget.vue?vue&type=template&id=1a858170&scoped=true&"
import script from "./WebPaymentQueueWidget.vue?vue&type=script&lang=js&"
export * from "./WebPaymentQueueWidget.vue?vue&type=script&lang=js&"
import style0 from "./WebPaymentQueueWidget.vue?vue&type=style&index=0&id=1a858170&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a858170",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VDivider,VIcon,VProgressCircular})
